import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsBarComponent } from './news-bar/news-bar.component';
import { SharedModule } from '../shared';

@NgModule({
    declarations: [NewsBarComponent],
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        NewsBarComponent
    ]
})
export class NewsModule { }
